export default __webpack_public_path__ + "static/media/fridge1-after2-1024w.8fb9fe06.avif";